import styled from 'styled-components';
import { Flex, Image, mediaBreakpointMixin, Spacer, token } from '@zillow/constellation';

export const StyledCenteredImage = styled(Image)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  @media ${mediaBreakpointMixin('lg')} {
    width: 60%;
  }
`;

export const StyledBlueBackgroundFlex = styled(Flex)`
  background-color: rgba(242, 250, 255, 1);
`;

export const StyledBorderedSpacer = styled(Spacer)`
  border: 1px solid ${token('colors.gray300')};
  flex: 1;
`;
